// Central place for all translations used in the application
export const defaultTranslations = {
  // CommandLine related translations
  welcome: "✨ Welcome to React Command Flow Terminal ✨",
  loading: "Loading",
  pleaseWait: "⌛ Please wait...",
  suggestions: "Suggestions: ",
  errorReadingHistory: "Error reading history from localStorage:",
  errorSavingHistory: "Error saving history to localStorage:",
  devWarningPromise:
    "[DEV WARNING] React tried to render a Promise at output index {idx}. Did you forget to await onComplete?",

  // useCommandFlow related translations
  helpTip: "Type `help` to see available commands.",
  errorReadingOutput: "Error reading output from localStorage:",
  errorSavingOutput: "Error saving output to localStorage:",
  commandCancelled: "❌ Command cancelled.",
  errorOccurred: "❌ An error occurred.",
  didYouMean: "Did you mean: {suggestions}?",

  // CommandFlowEngine related translations
  unknownCommand: "Unknown command: {commandName}. Type `help` for help.",
  noActiveSession: "No active command session.",
  failedToResolvePrompt: "Failed to resolve prompt.",
  failedToResolveNextPrompt: "Failed to resolve next prompt.",

  // Response options
  yes: "y",
  no: "n",
  exitCommands: ["exit", "cancel", "quit"],
  backCommands: ["back"],
};

// Helper function to apply translations with variable replacements
export function getTranslation(key, translations = {}, replacements = {}) {
  let text = translations[key] || defaultTranslations[key] || key;

  // Replace placeholders with actual values
  Object.entries(replacements).forEach(([placeholder, value]) => {
    text = text.replace(`{${placeholder}}`, value);
  });

  return text;
}
